import { Food } from "domain/entities/food";
import { Result } from "domain/entities/result";
import { FoodRepository } from "domain/repositories";

export default class UpdateUseCase {
    private foodRepository: FoodRepository;
    
    public constructor(foodRepository: FoodRepository) {
        this.foodRepository = foodRepository
    }

    public async updateFood(id: number, food: Food, token: Promise<[string | null, string | null]>): Promise<[Result, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.foodRepository.updateFood(id, food, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}